export default "__VITE_ASSET__qnD8Cwzd__"